import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const SelectMeta: ComponentMeta = {
  componentName: "Select",
  package: "@mijadesign/web",
  title: "选择器",
  description: "下拉选择器",
  category: ComponentCategory.FORM,
  icon: "DownSquareOutlined",
  canHaveChildren: false,
  designToken: {
    fields: [
      { name: "optionSelectedBg", label: "选中项背景", type: "color" },
      { name: "optionSelectedColor", label: "选中项文字", type: "color" },
      { name: "borderRadius", label: "圆角", type: "number", min: 0, max: 48 },
    ],
  },
  eventSources: [
    {
      name: "change",
      label: "值变化",
      trigger: "dom",
    },
    {
      name: "select",
      label: "选中",
      trigger: "dom",
    },
    {
      name: "focus",
      label: "聚焦",
      trigger: "dom",
    },
    {
      name: "blur",
      label: "失焦",
      trigger: "dom",
    },
  ],
  props: [
    {
      name: "placeholder",
      label: "占位提示",
      type: PropType.STRING,
      defaultValue: "请选择",
      group: "基础",
    },
    {
      name: "options",
      label: "选项",
      type: PropType.JSON,
      defaultValue: [
        { label: "选项一", value: "1" },
        { label: "选项二", value: "2" },
        { label: "选项三", value: "3" },
      ],
      description: "下拉选项配置",
      group: "数据",
    },
    {
      name: "mode",
      label: "模式",
      type: PropType.ENUM,
      options: [
        { label: "单选", value: undefined },
        { label: "多选", value: "multiple" },
        { label: "标签", value: "tags" },
      ],
      group: "基础",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "基础",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "allowClear",
      label: "可清空",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "showSearch",
      label: "可搜索",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
    {
      name: "loading",
      label: "加载中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "maxTagCount",
      label: "最多显示标签数",
      type: PropType.NUMBER,
      description: "多选模式下最多显示多少个标签",
      group: "多选",
    },
  ],
  defaultProps: {
    placeholder: "请选择",
    options: [
      { label: "选项一", value: "1" },
      { label: "选项二", value: "2" },
      { label: "选项三", value: "3" },
    ],
    style: { width: 200 },
  },
  defaultStyle: {
    width: 200,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Select",
  },
  snippet: {
    componentName: "Select",
    package: "@mijadesign/web",
    props: {
      placeholder: "请选择",
      options: [
        { label: "选项一", value: "1" },
        { label: "选项二", value: "2" },
        { label: "选项三", value: "3" },
      ],
    },
    style: { width: 200 },
  },
};
